import React from 'react';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import { LocationIcon, InfoIcon } from '../icons/icons';
import { useSelector } from 'react-redux';

export const CandidateInfo = (props) => {
    const { candidateInfo } = useSelector((state) => state?.candidateState);
    const { mobileView } = props;

    return (
        <Grid container display='flex' alignItems='center'>
            <Grid item alignItems='center' xs={12} sm={3}>
                <Avatar alt='Profile' sx={{ width: 100, height: 100, mx: 'auto', fontSize: '5em' }}>
                    {candidateInfo?.candidate_name?.charAt(0)}
                </Avatar>
            </Grid>
            {candidateInfo ? (
                <Grid item xs={12} sm={9}>
                    <Grid container spacing={2} textAlign={mobileView ? 'center' : 'left'}>
                        <Grid item xs={12}>
                            <Typography variant='h5' component='h1' fontWeight='bold'>
                                {candidateInfo?.candidate_name}
                            </Typography>
                        </Grid>
                        <Grid item xs={mobileView ? 6 : null}>
                            <Typography component='span' sx={{ mr: 0.8 }}>
                                <LocationIcon fontSize='inherit' />
                                <Typography
                                    component='span'
                                    variant='subtitle2'
                                    color='text.secondary'
                                    fontWeight='bold'
                                    sx={{ ml: 0.8 }}>
                                    {candidateInfo?.Location}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item xs={mobileView ? 6 : null}>
                            <Typography component='span'>
                                <InfoIcon fontSize='inherit' />
                                <Typography
                                    component='span'
                                    variant='subtitle2'
                                    color='text.secondary'
                                    fontWeight='bold'
                                    sx={{ ml: 0.8 }}>
                                    {candidateInfo?.info}
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            ) : (
                ''
            )}
        </Grid>
    );
};
